import "./skill.page.scss";
import HomeMainComp, {
  HomeMainCompProps,
} from "../../components/home-main-comp/home-main.comp";
import { SKILL_MAIN_COMP_DATA } from "../../data/pages/skills/skills.data";
import { useContext } from "react";
import { LanguageContext } from "../../contexts/language/language.context";

const Skill = () => {
  let skillData: HomeMainCompProps[] = SKILL_MAIN_COMP_DATA.en;
  const { l } = useContext(LanguageContext);
  if (l.code === "fr") {
    skillData = SKILL_MAIN_COMP_DATA.fr;
  } else if (l.code === "en") {
    skillData = SKILL_MAIN_COMP_DATA.en;
  }
  return (
    <div className="home-container skill-container">
      {skillData.map((hD) => (
        <HomeMainComp
          homeMainCompData={hD.homeMainCompData}
          key={hD.homeMainCompData.label}
        ></HomeMainComp>
      ))}
    </div>
  );
};

export default Skill;
